import React, { Component } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

class MenuItemSeattle extends Component {
  constructor(props) {
    super(props);

    this._itemRef = null;

    let itemDiameter = 0;
    let outerItemDiameter = 0;
    let shadowItemDiameter = 0;
    let itemOffset = 0;
    let outerItemOffset = 0;

    const { activeOuterItemDiameterPercentage, activeShadowItemDiameterPercentage, active, main } = this.props;

    itemDiameter = this.props.width / 100 * this.props.nonActiveItemDiameterPercentage;
    outerItemDiameter = this.props.width / 100 * activeOuterItemDiameterPercentage;
    shadowItemDiameter = this.props.width / 100 * activeShadowItemDiameterPercentage;
    outerItemOffset = (shadowItemDiameter - outerItemDiameter) / 2;
    itemOffset = (shadowItemDiameter - itemDiameter) / 2;

    this.state = {
      itemDiameter: itemDiameter,
      outerItemDiameter: outerItemDiameter,
      shadowItemDiameter: shadowItemDiameter,
      itemOffset: itemOffset,
      outerItemOffset: outerItemOffset,
      active: active,
      main: main,
      left: this.props.left,
      top: this.props.top,
      animated: false
    }
  }

  componentDidMount() {
    this._itemRef.addEventListener('click', this.handleClick);
  }

  componentWillUnmount() {
    this._itemRef.removeEventListener('click', this.handleClick);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.active !== this.props.active) {
      if (this.props.active) {
        this.activate();
      } else {
        this.deactivate();
      }
    }
  }
  
  handleClick = () => {
    if (!this.state.active) {
      this.props.handleClick(this.props.elementId, this.props.id, this._itemRef, this.changeItemStatus);
    }
  }

  changeItemStatus = (status) => {
    this.setState({
      active: status
    });
  }

  activate = () => {
    this._itemRef.animate([
      {
        transform:"scale(1.0)"
      },
      {
        transform:"scale(1.25)"
      }
    ], {
      fill: "forwards",
      duration: 300
    });
    this.setState({
      main: true,
      active: true,
      animated: true
    })
  }

  deactivate = () => {
    this._itemRef.animate([
      {
        transform:"scale(1.25)"
      },
      {
        transform:"scale(1.0)"
      }
    ], {
      fill: "forwards",
      duration: 300
    });
    this.setState({
      main: false,
      active: false,
      animated: true
    });
  }

  getCircleRef = () => {
    return this._itemRef;
  }

  render() {
    const { shadowItemDiameter, outerItemDiameter, active, animated } = this.state;
    let { itemDiameter } = this.state;
    
    let outerItemPosition = {
      left: this.state.left - ((outerItemDiameter - itemDiameter) / 2),
      top: this.state.top - ((outerItemDiameter - itemDiameter) / 2)
    }

    let shadowItemPosition = {
      left: this.state.left - ((shadowItemDiameter - itemDiameter) / 2),
      top: this.state.top - ((shadowItemDiameter - itemDiameter) / 2)
    }

    let borderRadius = "50%";
    let zIndex = this.state.main ? 9999 : 1;
    itemDiameter = active && !animated ? itemDiameter * 1.2 : itemDiameter;
    let top = active && !animated ? this.state.top - (((outerItemDiameter - itemDiameter) / 2)) : this.state.top;
    let left = active && !animated ? this.state.left - (((outerItemDiameter - itemDiameter) / 2)) : this.state.left;

    let fontSize = 12.5 / 100 * itemDiameter;
    if (active && !animated) {
      fontSize = 14 / 100 * itemDiameter;
    }

    return (
      <div>
        <CSSTransitionGroup
          component='div'
          className="fastfadedelay"
          style={{ minHeight: '100%' }}
          transitionName='example'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <div key={active}>
            {
              active ?
              <div>
                {/* Shadow Item */}
                <div style={{ zIndex: zIndex, position:"absolute", backgroundColor: "white", width: shadowItemDiameter, height: shadowItemDiameter, borderRadius: borderRadius, opacity:0.5, ...shadowItemPosition}}/>
                {/* Outer Item */}
                <div style={{ zIndex: zIndex, position:"absolute", backgroundColor: this.props.secondaryColor, width: outerItemDiameter, height: outerItemDiameter, borderRadius: borderRadius, ...outerItemPosition }}/>
              </div>
              :null
            }
          </div>
        </CSSTransitionGroup>

        {/* Item */}
        <div ref={el => this._itemRef = el} style={{ zIndex: zIndex, display:"flex", alignItems:"center", justifyContent:"center", position:"absolute", backgroundColor: this.props.color, width: itemDiameter, height: itemDiameter, borderRadius: borderRadius, top: top, left: left }}>
          <span className="noselect" style={{ fontSize: fontSize, textTransform:"uppercase", textAlign:"center" }}>{this.props.children}</span>
        </div>
      </div>
    );
  }
}

export default MenuItemSeattle;


// WEBPACK FOOTER //
// ./src/Components/Theme/Seattle/MenuItemSeattle.jsx